import React from 'react';
import { Layout as AntLayout } from 'antd';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const { Header, Content, Footer } = AntLayout;

const Layout = () => {
  return (
    <AntLayout className="layout">
      <Header>
        <Navbar />
      </Header>
      <Content style={{ padding: '50px' }}>
        <div className="site-layout-content">
          <Outlet />
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        电影搜索网站 ©{new Date().getFullYear()} Created by Your Name
      </Footer>
    </AntLayout>
  );
};

export default Layout; 